import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthOIDCService } from '../auth/authOIDC.service';
import { BaseService } from '../shared-service/base.service';
import { WindowRef } from '../shared-service/windowRef.service';

// import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

  constructor(private router: Router, private baseService: BaseService, private authOIDCService: AuthOIDCService,private winRef:WindowRef) {

  }

  ngOnInit() {

  }

  routeToLogin() {
    setTimeout(() => {
      if (this.baseService.isDirectLogin) {
        this.authOIDCService.logout();
        // this.winRef.nativeWindow.document.location.href = `${this.baseService.config.authServerBaseUrl}realms/${this.baseService.config.realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${this.baseService.config.lmsBaseUrl}learner&id_token_hint=${this.keycloakService.getKeycloakInstance().idToken}`;
        //this.keycloakService.logout(location.origin).then(() => this.keycloakService.clearToken()); 
      }
      this.baseService.logout();
    }, 1500);
  }

}
